/* Arflonia · Suchvorschläge beim Tippen (2026-11-03, Claude)
   Nutzt die vorhandenen Suchfelder (Kopfzeile Handy + Desktop, Suchseite) – kein neues Suchfeld.
   Zeigt passende Produkte, Kategorien und Suchbegriffe über Shopifys Predictive Search (/search/suggest.json).
   Enter oder Lupe sucht wie bisher. Zurücknehmen: Zeile mit arf-suggest.js in snippets/arf-ux-2026-11 entfernen. */
(function () {
  'use strict';
  if (window.__arfSuggest) return;
  window.__arfSuggest = true;

  var D = document, W = window;
  var SEL = '.pets-mobile-inline-search input[name="q"], .pets-search input[name="q"], .arfs-form input[name="q"]';
  var cache = {}, timer = 0, ctrl = null, panel = null, current = null, seq = 0;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(n); }
    catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
  }
  function sized(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  function searchUrl(q) {
    return '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }

  function ensurePanel() {
    if (panel) return panel;
    panel = D.createElement('div');
    panel.className = 'arfsg';
    panel.id = 'arf-suggest';
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'Suchvorschläge');
    panel.setAttribute('data-arf-skip', ''); /* Produktkarten-Skript (arf-site-style) soll die Vorschläge nicht umbauen */
    panel.hidden = true;
    D.body.appendChild(panel);
    panel.addEventListener('keydown', function (e) {
      var items = [].slice.call(panel.querySelectorAll('a'));
      var i = items.indexOf(D.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); if (items[i + 1]) items[i + 1].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) items[i - 1].focus(); else if (current) current.focus(); }
      else if (e.key === 'Escape') { close(); if (current) current.focus(); }
    });
    return panel;
  }

  function place() {
    if (!panel || panel.hidden || !current) return;
    var form = current.form || current;
    var r = form.getBoundingClientRect();
    var vw = D.documentElement.clientWidth;
    var vh = (W.visualViewport && W.visualViewport.height) || W.innerHeight;
    var top = Math.max(0, r.bottom + 6);
    if (vw < 750) {
      panel.style.left = '8px';
      panel.style.right = '8px';
      panel.style.width = 'auto';
    } else {
      var w = Math.max(r.width, 420);
      var left = Math.min(r.left, vw - w - 12);
      panel.style.left = Math.max(12, left) + 'px';
      panel.style.right = 'auto';
      panel.style.width = w + 'px';
    }
    panel.style.top = top + 'px';
    panel.style.maxHeight = Math.max(160, vh - top - 12) + 'px';
  }

  function close() {
    if (!panel) return;
    panel.hidden = true;
    panel.innerHTML = '';
    if (current) current.setAttribute('aria-expanded', 'false');
  }

  function render(q, data) {
    var p = ensurePanel();
    var res = (data && data.resources && data.resources.results) || {};
    var prods = res.products || [], cols = res.collections || [], qs = res.queries || [];
    var h = '';
    var sugg = qs.filter(function (x) { return x && x.text && x.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 4);
    if (sugg.length) {
      h += '<div class="arfsg__qs">';
      sugg.forEach(function (x) { h += '<a class="arfsg__q" href="' + esc(searchUrl(x.text)) + '">' + esc(x.text) + '</a>'; });
      h += '</div>';
    }
    if (cols.length) {
      h += '<p class="arfsg__h">Kategorien</p><div class="arfsg__cs">';
      cols.slice(0, 4).forEach(function (c) { h += '<a class="arfsg__c" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; });
      h += '</div>';
    }
    if (prods.length) {
      h += '<p class="arfsg__h">Produkte</p><ul class="arfsg__ps">';
      prods.slice(0, 6).forEach(function (x) {
        var im = x.featured_image && x.featured_image.url ? x.featured_image.url : x.image;
        var pmin = x.price_min != null ? x.price_min : x.price;
        var from = x.price_max != null && x.price_min != null && parseFloat(x.price_max) > parseFloat(x.price_min);
        h += '<li><a class="arfsg__p" href="' + esc(x.url) + '">' +
          (im ? '<img src="' + esc(sized(im, 120)) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="arfsg__ph"></span>') +
          '<span class="arfsg__t">' + (x.vendor ? '<b>' + esc(x.vendor) + '</b> ' : '') + esc(x.title) + '</span>' +
          '<span class="arfsg__pr">' + (from ? 'ab ' : '') + esc(money(pmin)) + (x.available === false ? '<em>ausverkauft</em>' : '') + '</span>' +
          '</a></li>';
      });
      h += '</ul>';
    }
    if (!prods.length && !cols.length) {
      h += '<p class="arfsg__none">Keine direkten Vorschläge. Mit Enter suchst du in allen Produkten.</p>';
    }
    h += '<a class="arfsg__all" href="' + esc(searchUrl(q)) + '">Alle Ergebnisse für „' + esc(q) + '“ anzeigen</a>';
    p.innerHTML = h;
    p.hidden = false;
    if (current) current.setAttribute('aria-expanded', 'true');
    place();
  }

  function load(q) {
    var key = q.toLowerCase();
    if (cache[key]) { render(q, cache[key]); return; }
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = W.AbortController ? new AbortController() : null;
    var my = ++seq;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product,collection,query&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
      '&resources%5Boptions%5D%5Bfields%5D=title,product_type,vendor,tag,variants.title';
    fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || my !== seq) return;
        cache[key] = data;
        if (current && current.value.trim().toLowerCase() === key) render(q, data);
      })
      .catch(function () {});
  }

  function onInput(e) {
    current = e.target;
    var q = current.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { close(); return; }
    timer = setTimeout(function () { load(q); }, 180);
  }

  D.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches(SEL)) onInput(e);
  }, true);

  D.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(SEL)) {
      current = t;
      t.setAttribute('autocomplete', 'off');
      t.setAttribute('aria-controls', 'arf-suggest');
      if (t.value.trim().length >= 2) load(t.value.trim());
    }
  });

  D.addEventListener('keydown', function (e) {
    if (!panel || panel.hidden || !current || e.target !== current) return;
    if (e.key === 'ArrowDown') {
      var first = panel.querySelector('a');
      if (first) { e.preventDefault(); first.focus(); }
    } else if (e.key === 'Escape') {
      close();
    }
  });

  D.addEventListener('pointerdown', function (e) {
    if (!panel || panel.hidden) return;
    if (panel.contains(e.target)) return;
    if (current && (e.target === current || (current.form && current.form.contains(e.target)))) return;
    close();
  }, true);

  D.addEventListener('submit', function (e) {
    if (current && e.target === current.form) close();
  }, true);

  W.addEventListener('resize', place, { passive: true });
  W.addEventListener('scroll', place, { passive: true });
  if (W.visualViewport) W.visualViewport.addEventListener('resize', place, { passive: true });
  W.addEventListener('pageshow', close);
})();
